import { Box, Icon, Image } from '@betty/moonlight';

function FooterPayments() {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="space-600"
      width="100%"
    >
      <Box position="relative">
        <Icon name="visaCard" width="space-2000" height="space-1000" />
        <Image
          name="common.BettyBadge"
          width="space-400"
          height="space-600"
          position="absolute"
          bottom="-space-300"
          right="-space-200"
        />
      </Box>
      <Image name="common.Interac" width="space-1400" height="space-1400" />
      <Icon name="masterCard" width="space-1000" height="space-500" />
    </Box>
  );
}

export default FooterPayments;
